// extracted by mini-css-extract-plugin
export default {"sort":"PU-z","sortSelect":"QU-z","disabled":"RU-z"};